export const FETCH_SITEMAP = {
  init: 'sitemap/FETCH_SITEMAP/init',
  request: 'sitemap/FETCH_SITEMAP/request',
  success: 'sitemap/FETCH_SITEMAP/success',
  failure: 'sitemap/FETCH_SITEMAP/failure',
} as const;

export const SITEMAP_STORE_NAME = 'sitemap' as const;
